module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "current-action",
    class: {
      visible: _vm.currentActionMessage
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentActionMessage),
      expression: "currentActionMessage"
    }],
    staticClass: "message shadow",
    domProps: {
      "innerHTML": _vm._s(_vm.currentActionMessage)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c35ad278","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CurrentAction.vue
// module id = 568
// module chunks = 1